import { Component, Input } from '@angular/core';
import { AppComponent } from 'app/app.component';
import { CommunicationService } from 'app/_services/communication.service';
import { RADController } from 'app/_controllers/radController';
import { ISelectedLine } from 'app/_models/ISelectedLine';
import { IAction } from 'app/_models/IAction';
import { IGanttTask } from 'app/_models/IGanttTask';
import { ISettings } from 'app/_models/ISettings';
import { IconDefinition, faSquareCheck, faXmark, faCheckDouble } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'sql-action-component',
  templateUrl: './sql-action.component.html',
  styleUrls: ['./sql-action.component.css']
})
export class SqlActionComponent {
  //#region Fields & Icons
  @Input() settings: ISettings;
  @Input() action: IAction;
  @Input() selectedItems: ISelectedLine[] | IGanttTask[] = [];
  @Input() nodeId: string;
  @Input() userId: string;
  i: number = 0;
  updateFeedbackMessage: string = '';
  faSquareCheck: IconDefinition = faSquareCheck;
  faCheckDouble: IconDefinition = faCheckDouble;
  faXmark: IconDefinition = faXmark;
  //#endregion Fields

  constructor(
    public app: AppComponent,
    private radController: RADController,
    private communicationService: CommunicationService
  ) { }

  confirm(): void {
    this.app.showLoader();
    this.i = 0;
    this.updateFeedbackMessage = '';
    if (this.selectedItems.length > 0) this.save();
    else {
      this.radController.sqlExecute(this.nodeId, this.userId, this.action.id, '', this.action.executePerLine).then(result => {
        this.app.hideLoader();
        if (result == '') {
          this.app.alertSuccess(this.app.translations.ALERT_Success_Success);
          this.communicationService.closeDialog();
          this.communicationService.refreshAll();
        } else this.communicationService.showFeedbackDialog(result);
      });
    }
  }

  save(): void {
    if (this.i == this.selectedItems.length) {
      this.app.hideLoader();
      if (this.updateFeedbackMessage == '') {
        this.app.alertSuccess(this.app.translations.ALERT_Success_Success);        
        this.communicationService.closeDialog();
        this.communicationService.refreshAll();
        return;
      }

      this.communicationService.showFeedbackDialog(this.updateFeedbackMessage);
      return;
    }

    this.radController.sqlExecute(this.nodeId, this.userId, this.action.id, this.selectedItems[this.i].id, this.action.executePerLine).then(result => {      
      if (result != '') this.updateFeedbackMessage += result;
      this.i++;
      this.app.loaderText = `${this.i} ${this.app.translations.GBL_lbl_Of} ${this.selectedItems.length} ${this.app.translations.GBL_lbl_Saved}`;
      this.save();
    });
  }
}
